import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { HeadingFormControl } from "../Web/HeadingFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { LabelFormControl } from "../Web/LabelFormControl";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col = new XColumnContainerColumn();

    container.add(col);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Heading";
    col.add(label);

    let Heading = new HeadingFormControl();
    Heading.type = "h1";
    Heading.text = "h1";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "h2";
    Heading.text = "h2";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "h3";
    Heading.text = "h3";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "h4";
    Heading.text = "h4";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "h5";
    Heading.text = "h5";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "h6";
    Heading.text = "h6";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "subtitle1";
    Heading.text = "subtitle1";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "subtitle2";
    Heading.text = "subtitle2";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "body1";
    Heading.text = "body1";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "caption";
    Heading.text = "caption";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "button";
    Heading.text = "button";
    Heading.valueName = "value";
    col.add(Heading);

    Heading = new HeadingFormControl();
    Heading.type = "overline";
    Heading.text = "overline";
    Heading.valueName = "value";
    col.add(Heading);

    return { form: ui };
}

export const HeadingStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Heading",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            for (let c of ui.form.getAllControls()) {
                (c as HeadingFormControl).color = UIStyleConstants.BLUE_COLOR;
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Heading",
        "Color",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            for (let c of ui.form.getAllControls()) {
                (c as HeadingFormControl).background = UIStyleConstants.BLUE_COLOR;
                (c as HeadingFormControl).color = UIStyleConstants.WHITE_COLOR;
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Heading",
        "Background Color",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            for (let c of ui.form.getAllControls()) {
                (c as HeadingFormControl).textAlign = "center";
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Heading",
        "Center",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            for (let c of ui.form.getAllControls()) {
                (c as HeadingFormControl).fromData = true;
            }

            let data = new ExecutionData();
            data.values["value"] = "This is from form data";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Heading",
        "FromData",
    ),
];
